import type React from 'react';
import everfieldLogo from '../assets/Everfield-Group.png';
import ugLogo from '../assets/ug-logo-small 1 1.svg';
import './Footer.css';

export default function Footer(): React.JSX.Element {
  return (
    <footer id="footer-section" className="footer">
      <div className="footer__inner">
        <div className="footer__logo-wrap">
          <img src={everfieldLogo} alt="Everfield" className="footer__logo" />
        </div>
        <div className="footer__bottom">
          <p className="footer__copy">© Everfield 2026. All Rights Reserved.</p>
          <a
            href="https://unknowngroup.com.au/"
            target="_blank"
            rel="noopener noreferrer"
            className="footer__site-by"
          >
            <img src={ugLogo} alt="Unknown Group" className="footer__ug-logo" />
            <p className="footer__site-by-text">Site by Unknown.</p>
          </a>
        </div>
      </div>
    </footer>
  );
}
